import React, { useState, useLayoutEffect, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle'; 
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
    Input,
    GrayButton,
    NomalButton
} from '../../css/CSS.js';
import UndoIcon from '@mui/icons-material/Undo';
import UploadIcon from '@mui/icons-material/Upload';
export default function AccountManagementImportNoticeDialog(props) {

    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false)
        props.closeClick();
    };

    useEffect(() => {
        setOpen(props.open)
    },[props.open])

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md" 
            closeAfterTransition={false}
        ><Grid container direction="row"
            sx={{
                justifyContent: "center",
                alignItems: "center",
                p: 3,
                backgroundColor: "#1976d2",
            }}>
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: '2rem', color: '#ffffff', py: 0 }}>
                    {"請負担当者一括登録"}
                </DialogTitle>
            </Grid>
            <DialogContent sx={{ px: 10, py: 5 }}>
                <Typography sx={{ fontSize: '1.5rem' }}>
                    新規登録時にパスワードを空欄にすることで<br />
                    システムデフォルトパスワードを指定することが出来ます。
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}>
                    <GrayButton variant="contained" size="large" onClick={handleClose}
                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                        <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                        キャンセル
                    </GrayButton>
                    <label htmlFor="csvImport">
                        <Input
                            accept=",.csv"
                            id="csvImport"
                            type="file"
                            value=''
                            key={props.inputKey}
                            multiple
                            onChange={(e) => props.onFileImport(e)}
                            ref={props.inputRef}
                        />
                        <NomalButton variant="contained"
                            sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} 
                            component="span">
                            <UploadIcon sx={{ mr: 2, fontSize: '2rem' }} /> ファイルを選択
                        </NomalButton>
                    </label>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}